module.exports = __webpack_public_path__ + "img/play.5995c02d.svg";